import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { WidgetType } from "scenes/cohort-filters/filter-configs/widgetTypes";

export const nestedFieldConstructor = ({
    nestedPath = null,
    category = Category.OTHER,
    label,
    allowAndCondition = false,
    allowOrCondition = false,
    andConditionLabel = "",
    canExclude = false,
    nestedConfigs,
    virtualFieldPaths = [],
    additionalFieldProperties: additionalFieldsProperties = {},
    showLabel = true,
}) => {
    //TODO LM: nestedPath is never missing
    const fieldName = nestedPath || nestedConfigs.map((nestedConfig) => Object.keys(nestedConfig)[0]).join("|");
    const nestedValues = nestedConfigs.map((nestedConfig) => {
        const field = Object.keys(nestedConfig)[0];
        const configValue = nestedConfig[field];
        const defaultValue = configValue?.defaultRuleProperties?.value ?? "";
        const widgetType = configValue?.widgetType;
        const additionalFieldProperties = additionalFieldsProperties[field] || {};
        return {
            properties: {
                field,
                widgetType,
                virtualField: virtualFieldPaths.includes(field) || undefined,
                value: defaultValue,
                ...additionalFieldProperties,
            },
            type: "rule",
        };
    });
    const mainNestedConfig = {
        [fieldName]: {
            widgetType: WidgetType.NESTED,
            category: category,
            widgetConfig: {
                label,
                showLabel,
                allowOrCondition,
                allowAndCondition,
                andConditionLabel,
                canExclude,
            },
            defaultRuleProperties: {
                exclude: false,
                nestedPath: nestedPath ? nestedPath : undefined,
                value: {
                    type: "nested",
                    nestedValues: nestedValues,
                },
            },
        },
    };
    const nestedConfigWithNestedComponents = nestedConfigs.reduce((acc, current) => {
        const [key, value] = Object.entries(current)[0];
        return { ...acc, [key]: value };
    }, mainNestedConfig);
    return nestedConfigWithNestedComponents;
};
